import { Injectable } from '@angular/core';
import { CancelCashOutRequestEntity } from '@shared/core/entities/cancel-cash-out-request.entity';
import { CancelCashOutUseCase } from '@shared/core/usecases/cancel-cash-out/cancel-cash-out.use-case';
import { CancelCashOutRepository } from '@shared/core/repositories/cancel-cash-out/cancel-cash-out.repository';
import { CancelCashOutResponseEntity } from '@shared/core/entities';


@Injectable()
export class CancelCashOutInteractor {

  public cancelCashOutUseCase: CancelCashOutUseCase;

  constructor(private readonly cancelCashOutRepository: CancelCashOutRepository) {
    this.cancelCashOutUseCase = new CancelCashOutUseCase(cancelCashOutRepository);
  }

  public cancelTransaction(params: CancelCashOutRequestEntity): Promise<CancelCashOutResponseEntity> {
    return this.cancelCashOutUseCase.execute(params);
  }

}
